// Learner Login and signuo
export const LEARNER_LOGIN_PENDING = "LEARNER_LOGIN_PENDING";
export const LEARNER_LOGIN_COMPLETE = "LEARNER_LOGIN_COMPLETE";
export const LEARNER_LOGIN_ERROR = "LEARNER_LOGIN_ERROR";
export const LEARNER_SIGN_UP_PENDING = "LEARNER_SIGN_UP_PENDING";
export const LEARNER_SIGN_UP_COMPLETE = "LEARNER_SIGN_UP_COMPLETE";
export const LEARNER_SIGN_UP_ERROR = "LEARNER_SIGN_UP_ERROR";

// instructor login
export const INSTRUCTOR_LOGIN_PENDING = "INSTRUCTOR_LOGIN_PENDING";
export const INSTRUCTOR_LOGIN_COMPLETE = "INSTRUCTOR_LOGIN_COMPLETE";
export const INSTRUCTOR_LOGIN_ERROR = "INSTRUCTOR_LOGIN_ERROR";

// admin login
export const ADMIN_LOGIN_PENDING = "ADMIN_LOGIN_PENDING";
export const ADMIN_LOGIN_COMPLETE = "ADMIN_LOGIN_COMPLETE";
export const ADMIN_LOGIN_ERROR = "ADMIN_LOGIN_ERROR";
export const ADMIN_LOGOUT = "ADMIN_LOGOUT";

// OTPs
export const OTP_PENDING = "OTP_PENDING";
export const OTP_VERIFIED = "OTP_VERIFIED";
export const OTP_ERROR = "OTP_ERROR";
// success and error
export const CLEAR_ERROR = "CLEAR_ERROR";
export const CLEAR_SUCCESS = "CLEAR_SUCCESS";
export const SET_JWTTOKEN = "SET_JWTTOKEN";

// instructor naming
export const SET_INSTRUCTOR = "SET_INSTRUCTOR";
export const DELETE_INSTRUCTOR = " DELETE_INSTRUCTOR";

// suburbs naming
export const SET_SUBURBS = "SET_SUBURBS";
export const DELETE_SUBURBS = "DELETE_SUBURBS";

// lesson price namings
export const SET_LESSON_PRICE = "SET_LESSON_PRICE";
export const DELETE_LESSON_PRICE = "DELETE_LESSON_PRICE";

// cart namings
export const SET_CART = "SET_CART";
export const DELETE_CART = " DELETE_CART";

// set billing
export const SET_BILLING = "SET_BILLING";

// booking reduer
export const BOOKING_PENDING = "BOOKING_PENDING";
export const BOOKING_SUCCESS = "BOOKING_SUCCESS";
export const BOOKING_FAILED = "BOOKING_FAILED";
export const SET_BOOKING = "SET_BOOKING";
export const DELETE_BOOKING = "DELETE_BOOKING";
export const SET_PICKUP_DETAILS = "SET_PICKUP_DETAILS";
export const DELETE_PICKUP_DETAILS = "DELETE_PICKUP_DETAILS";

// booking reduer
export const PURCHASE_CREDIT_PENDING = "PURCHASE_CREDIT_PENDING";
export const PURCHASE_CREDIT_SUCCESS = "PURCHASE_CREDIT_SUCCESS";
export const PURCHASE_CREDIT_ERROR = "PURCHASE_CREDIT_ERROR";

// view boookings
export const SET_ACTIVE_BOOKING = "SET_ACTIVE_BOOKING";
export const DELETE_ACTIVE_BOOKING = "DELETE_ACTIVE_BOOKING";

// admin data
export const ADMIN_USERS_PENDING = "ADMIN_USERS_PENDING";
export const ADMIN_USERS_SUCCESS = "ADMIN_USERS_SUCCESS";
export const ADMIN_USERS_ERROR = "ADMIN_USERS_ERROR";

export const ADMIN_BOOKINGS_PENDING = "ADMIN_BOOKINGS_PENDING";
export const ADMIN_BOOKINGS_SUCCESS = "ADMIN_BOOKINGS_SUCCESS";
export const ADMIN_BOOKINGS_ERROR = "ADMIN_BOOKINGS_ERROR";

export const ADMIN_INSTRUCTORS_PENDING = "ADMIN_INSTRUCTORS_PENDING";
export const ADMIN_INSTRUCTORS_SUCCESS = "ADMIN_INSTRUCTORS_SUCCESS";
export const ADMIN_INSTRUCTORS_ERROR = "ADMIN_INSTRUCTORS_ERROR";

export const GET_SUBURBS_PENDING = "GET_SUBURBS_PENDING";
export const GET_SUBURBS_SUCCESS = "GET_SUBURBS_SUCCESS";
export const GET_SUBURBS_ERROR = "GET_SUBURBS_ERROR";

// Send Promise Reducer
export const PROMISE_SENT = "PROMISE_SENT";
export const PROMISE_RESOLVED = "PROMISE_RESOLVED";
export const PROMISE_REJECTED = "PROMISE_REJECTED";
export const DESTROY_PROMISE = "DESTROY_PROMISE";

// financial reports
export const GET_REPORTS_PENDING = "GET_REPORT_PENDING";
export const GET_REPORTS_SUCCESS = "GET_REPORTS_SUCCESS";
export const GET_REPORTS_ERROR = "GET_REPORTS_ERROR";
